import React from "react";
import List from "./List";
var InlineList = function InlineList(props) {
  return React.createElement(List, props);
};
export default InlineList;